'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _immutable = require('immutable');

var _userInfo = require('hub-http/userInfo');

var _userInfo2 = _interopRequireDefault(_userInfo);

var _noAuthApiClient = require('../utils/http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _hublessCheckAuth = require('../auth/hublessCheckAuth');

var _hublessCheckAuth2 = _interopRequireDefault(_hublessCheckAuth);

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _PortalIdContainer = require('../globals/PortalIdContainer');

var _PortalIdContainer2 = _interopRequireDefault(_PortalIdContainer);

var _portalRegex = require('../constants/portalRegex');

var _portalRegex2 = _interopRequireDefault(_portalRegex);

var _AnalyticsActions = require('../actions/AnalyticsActions');

var _UsageTrackerContainer = require('../tracking/UsageTrackerContainer');

var _UsageTrackerContainer2 = _interopRequireDefault(_UsageTrackerContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// TODO: move to core/auth folder
var Auth = function () {
  function Auth() {
    _classCallCheck(this, Auth);

    this.data = {
      auth: null,
      user: null,
      gates: null,
      portal: null,
      portalId: null,
      userId: null
    };
    this.initialized = false;
  }

  _createClass(Auth, [{
    key: 'refreshAuth',
    value: function refreshAuth(portalId) {
      this.initialized = false;
      return this.init({
        // force new portalId on existing user portal create
        portalId: portalId || _PortalIdContainer2.default.get()
      });
    }
  }, {
    key: 'checkAuth',
    value: function checkAuth() {
      var authOptsOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var authOpts = this.getAuthOpts();
      authOpts = Object.assign(authOpts, authOptsOverrides);
      return (0, _hublessCheckAuth2.default)(authOpts);
    }
  }, {
    key: 'init',
    value: function init() {
      var _this = this;

      var authOptsOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (this.initialized) {
        return _q2.default.Promise.resolve(this.data);
      }

      if (authOptsOverrides.portalId) {
        // Manual set on PortalIdParser for new portal creation with existing user
        _hubspot2.default.id = authOptsOverrides.portalId;
      } else {
        _hubspot2.default.get({
          reparse: true,
          preserveGlobalId: false,
          regex: _portalRegex2.default
        });
      }

      return this.checkAuth(authOptsOverrides).then(function (auth) {
        if (auth.hubIds && auth.hubIds.length) {
          return _this.setAuth(auth);
        }
        return _this.setAuthHubless();
      }).catch(function () {
        var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (err.portalId) {
          (0, _AnalyticsActions.trackEvent)('interaction', { action: 'expired trial signup attempt' });
          return _this.setAuth({});
        }
        return _q2.default.Promise.reject();
      });
    }
  }, {
    key: 'getAuthOpts',
    value: function getAuthOpts() {
      return {
        forceRefresh: true,
        onExpired: false
      };
    }
  }, {
    key: 'get',
    value: function get() {
      return _extends({}, this.data, {
        initialized: this.initialized
      });
    }
  }, {
    key: 'setAuthHubless',
    value: function setAuthHubless() {
      var _this2 = this;

      // need to do a refresh of data in all init cases
      this.initialized = true;

      return _noAuthApiClient2.default.get('/login-verify/user-info').then(function (res) {
        var user = res.user;

        var userId = parseInt(user.id, 10);
        var email = user.emails[0];
        _this2.data = {
          auth: {},
          user: (0, _immutable.fromJS)({
            first_name: user.firstName,
            last_name: user.lastName,
            language: user.language,
            email: email,
            emails: user.emails,
            lang_enabled: user.langEnabled,
            locale: user.locale,
            user_id: userId,
            verified: !!user.verifiedAt
          }),
          gates: [],
          portal: {},
          portalId: undefined,
          userId: userId
        };

        // When a user is properly authed, re-initialize tracker
        var updatedUsageTrackerConfig = {
          namespace: 'signup',
          email: email,
          hstc: _UsageTrackerContainer.getTrackerHstc,
          userId: userId
        };
        _UsageTrackerContainer2.default.setProperties(updatedUsageTrackerConfig);
        return _this2.data;
      });
    }
  }, {
    key: 'setAuth',
    value: function setAuth(auth) {
      var _this3 = this;

      // need to do a refresh of data in all init cases
      this.initialized = true;

      return (0, _userInfo2.default)({
        cached: false,
        ignoreRedirect: true,
        portalId: auth.hubIds[0]
      }).then(function (_ref) {
        var user = _ref.user,
            gates = _ref.gates,
            portal = _ref.portal;

        var userId = parseInt(user.user_id, 10);
        _this3.data = {
          auth: auth,
          user: (0, _immutable.fromJS)(user),
          gates: gates,
          portal: (0, _immutable.fromJS)(portal),
          portalId: parseInt(portal.portal_id, 10),
          userId: userId
        };

        // When a user is properly authed, re-initialize tracker
        var updatedUsageTrackerConfig = {
          namespace: 'signup',
          email: user.email,
          hubId: _hubspot2.default.get(),
          hstc: _UsageTrackerContainer.getTrackerHstc,
          userId: userId
        };
        _UsageTrackerContainer2.default.setProperties(updatedUsageTrackerConfig);
        return _this3.data;
      });
    }
  }]);

  return Auth;
}();

exports.default = new Auth();
module.exports = exports['default'];